module.exports = __webpack_public_path__ + "img/nodata-02.ace14427.png";